import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Text } from '@chakra-ui/react';
import { formatCurrency, formatDataTestId, formatDate, formatPrice, useSemanticTypography, useCustomLocale } from '@whitbread-eos/utils';
import ChevronDown from '../../assets/icons/ChevronDown';
import ChevronUp from '../../assets/icons/ChevronUp';
import Icon from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RoomCardHeader(_ref) {
  var roomReservationStartDate = _ref.roomReservationStartDate,
    roomReservationEndDate = _ref.roomReservationEndDate,
    roomNumber = _ref.roomNumber,
    roomTotalPrice = _ref.roomTotalPrice,
    currency = _ref.currency,
    currentLang = _ref.currentLang,
    showRoomCardInfo = _ref.showRoomCardInfo,
    handleExpandCollapse = _ref.handleExpandCollapse,
    t = _ref.t;
  var baseDataTestId = formatDataTestId('RoomCardHeader', "room".concat(roomNumber));
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language;
  var getTypographyProps = useSemanticTypography();
  return _jsxs(Flex, _objectSpread(_objectSpread({
    "data-testid": baseDataTestId,
    onClick: () => handleExpandCollapse(roomNumber)
  }, roomNrContainerStyle), {}, {
    mb: showRoomCardInfo ? '2xl' : '0',
    pb: showRoomCardInfo ? '0' : 'lg',
    direction: showRoomCardInfo ? {
      mobile: 'column-reverse',
      xl: 'row'
    } : {
      mobile: 'column-reverse',
      xl: 'row'
    },
    children: [_jsxs(Flex, {
      w: "full",
      direction: "row",
      justify: "flex-start",
      children: [_jsx(Text, _objectSpread(_objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, 'Label')
      }, roomNrLayoutStyles), getTypographyProps(roomNrLegacyTypography, roomNrSemanticTypography)), {}, {
        children: t('booking.confirmation.room').replace('[roomNumber]', roomNumber.toString())
      })), _jsxs(Text, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, 'Dates')
      }, getTypographyProps(roomDatesLegacyTypography, roomDatesSemanticTypography)), {}, {
        children: [formatDate(roomReservationStartDate, 'd MMM', currentLang), " -", ' ', formatDate(roomReservationEndDate, 'd MMM', currentLang)]
      }))]
    }), _jsxs(Flex, _objectSpread(_objectSpread({}, roomPriceStyle), {}, {
      mb: showRoomCardInfo ? {
        xl: '0',
        mobile: 'md'
      } : {
        mobile: '0'
      },
      justifyContent: showRoomCardInfo ? {
        mobile: 'space-between',
        xl: 'flex-end'
      } : {
        mobile: 'space-between',
        xl: 'flex-end'
      },
      children: [_jsx(Text, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, 'Total-Label'),
        mr: "sm"
      }, getTypographyProps({}, roomTotalLabelSemanticTypography)), {}, {
        children: t('booking.hotel.summary.roomTotal')
      })), _jsxs(Flex, {
        alignItems: "center",
        children: [_jsx(Text, _objectSpread(_objectSpread({
          "data-testid": formatDataTestId(baseDataTestId, 'Total-Amount'),
          mr: "sm"
        }, getTypographyProps(roomTotalAmountLegacyTypography, roomTotalAmountSemanticTypography)), {}, {
          children: formatPrice(formatCurrency(currency), roomTotalPrice.toFixed(2), language)
        })), _jsx(Icon, {
          svg: showRoomCardInfo ? _jsx(ChevronUp, {
            color: "var(--chakra-colors-darkGrey2)"
          }) : _jsx(ChevronDown, {
            color: "var(--chakra-colors-darkGrey2)"
          })
        })]
      })]
    }))]
  }));
}
var roomNrLayoutStyles = {
  mr: 'md',
  w: 'fit-content'
};
var roomNrLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: {
    mobile: 'xl',
    xs: '2xl'
  }
};
var roomNrSemanticTypography = {
  textStyle: 'body-l-emphasis'
};
var roomDatesLegacyTypography = {
  fontSize: {
    mobile: 'xl',
    xs: '2xl'
  }
};
var roomDatesSemanticTypography = {
  textStyle: 'body-l-regular'
};
var roomTotalLabelSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var roomTotalAmountLegacyTypography = {
  fontWeight: 'bold'
};
var roomTotalAmountSemanticTypography = {
  textStyle: 'body-l-emphasis'
};
var roomNrContainerStyle = {
  fontSize: '2xl',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  p: 'lg'
};
var roomPriceStyle = {
  fontSize: 'xl',
  w: 'full',
  alignItems: 'center'
};